import { Fragment } from 'react';
import { CoinIcon } from '@/shared/ui/CoinIcon';

/** The literal coin emoji authors drop into copy as a placeholder for the canonical glyph. */
const COIN_MARKER = '🪙';

/**
 * Render a translated string, swapping every literal {@link COIN_MARKER} (🪙) for the canonical gold
 * {@link CoinIcon} SVG — so a coin in warm copy (the hero's voice line, a "ways to earn" hint) reads as
 * the SAME shape as every reward chip/balance, instead of the OS-drawn emoji.
 *
 * The emoji stays in the i18n catalog as a translator-friendly marker (no new params, ADR-0025); only
 * the rendering is canonicalised. Returns the plain string untouched when it carries no coin marker.
 */
export function coinGlyphText(text: string): React.ReactNode {
  if (!text.includes(COIN_MARKER)) return text;
  const parts = text.split(COIN_MARKER);
  return parts.map((part, i) => (
    <Fragment key={i}>
      {part}
      {i < parts.length - 1 && <CoinIcon className="text-warning" />}
    </Fragment>
  ));
}
